// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmail_container__nnoKp"};